import cn from 'classnames';
import { useToggleButtonGroupContext } from './ToggleButtonGroupContext';
import { groupItemSizeClassMap, groupItemThemeClassMap } from './constants';
import styles from './toggleButtonGroup.module.scss';

export interface IProps {
  /** Unique value identifying this item within the group */
  value: string,
  /** Whether the item is disabled */
  disabled?: boolean,
  /** Item content */
  children: React.ReactNode,
  /** Additional CSS class names */
  className?: string,
  /** Native tooltip text, exposed as the `title` attribute */
  title?: string,
  /** Test selector */
  dataTest: string,
}

const ToggleButtonGroupItem = ({
  value,
  disabled = false,
  children,
  className,
  title,
  dataTest,
}: IProps): React.ReactElement => {
  const {
    size,
    theme,
    value: selectedValues,
    onChange,
  } = useToggleButtonGroupContext();

  const pressed = selectedValues.includes(value);

  return (
    <button
      type="button"
      aria-pressed={ pressed }
      disabled={ disabled }
      className={ cn(
        styles.item,
        groupItemSizeClassMap[size],
        groupItemThemeClassMap[theme],
        { [styles.pressed]: pressed },
        className,
      ) }
      title={ title }
      data-test={ dataTest }
      onClick={ () => onChange(value) }
    >
      { children }
    </button>
  );
};

export default ToggleButtonGroupItem;
